module.exports = __webpack_public_path__ + "static/media/Suzuki-Go-Lockup-x1.7d830ee7.png";